import classnames from 'classnames';
import React, { useCallback } from 'react';
import {
  MdLayers as LayerOnIcon,
  MdLayersClear as LayerOffIcon,
} from 'react-icons/md';
import { createUseStyles } from 'react-jss';
import { useDispatch, useSelector } from 'react-redux';

import { toggleFilter } from '../../redux/actions';

const useStyles = createUseStyles({
  button: {
    '&:hover': { color: '#FFFFFF' },
    background: '#272727',
    borderRadius: 16,
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.45)',
    color: '#919191',
    composes: ['is-block', 'no-overflow', 'mb6'],
    height: 32,
    transition: 'color 0.3s, background 0.3s',
    width: 32,
  },
  icon: {
    verticalAlign: 'middle',
  },
});

const ToggleLayersComponent = React.memo(() => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const filters = useSelector(_ => _.filters);
  const hidden = filters.includes('zoomlevel');

  const clickHandler = useCallback(
    (types, visible) => dispatch(toggleFilter(types, visible)),
    [dispatch]
  );

  return (
    <button
      className={classnames(classes.button, { hidden })}
      type="button"
      onClick={() => clickHandler(['zoomlevel'], !hidden)}>
      {hidden && <LayerOnIcon className={classes.icon} size={16} />}
      {!hidden && <LayerOffIcon className={classes.icon} size={16} />}
    </button>
  );
});

ToggleLayersComponent.displayName = 'ToggleLayersComponent';

export default ToggleLayersComponent;
